import React from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import { defaultActionCellButtonCDSProps } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { formatDate } from 'utils/date';

import {
  ExceptionsTableColumnId,
  LoanExceptionCategoryLabels,
  LoanExceptionStatusLabels,
  LoanExceptionStatusLabelVariants,
} from '../Exceptions.constants';

import { DATE_COLUMN_WIDTH, EMPTY_VALUE } from './ExceptionsTable.constants';
import RowActionButton from './RowActionButton';

export const exceptionsTableConfig = {
  [ExceptionsTableColumnId.CATEGORY]: {
    label: 'Category',
    content: ({ category }) => LoanExceptionCategoryLabels[category] || category || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.SUB_CATEGORY_NAME]: {
    label: 'Sub-category',
    content: ({ subCategoryName }) => subCategoryName || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.SUBJECT]: {
    label: 'Subject',
    content: ({ subject }) => subject || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.STATUS]: {
    label: 'Status',
    content: ({ status }) => (
      <LabelCDS
        size={LabelSize.S}
        title={LoanExceptionStatusLabels[status] || status}
        variant={LoanExceptionStatusLabelVariants[status]}
      />
    ),
  },
  [ExceptionsTableColumnId.REQUESTED_BY_USER_NAME]: {
    label: 'Requested by',
    content: ({ requestedByUserName }) => requestedByUserName || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.REQUESTED_DATE]: {
    label: 'Requested',
    width: DATE_COLUMN_WIDTH,
    content: ({ requestedDate }) =>
      formatDate(requestedDate, COMMON_DATETIME_FORMAT) || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.DECIDED_BY_USER_NAME]: {
    label: 'Decided by',
    content: ({ decidedByUserName }) => decidedByUserName || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.DECISIONED_DATE]: {
    label: 'Decided',
    width: DATE_COLUMN_WIDTH,
    content: ({ decisionedDate }) =>
      formatDate(decisionedDate, COMMON_DATETIME_FORMAT) || EMPTY_VALUE,
  },
  [ExceptionsTableColumnId.ACTION]: {
    ...defaultActionCellButtonCDSProps,
    content: rowData => <RowActionButton rowData={rowData} />,
  },
};
